import { render } from "./CenterHCPList.vue?vue&type=template&id=f4a90e24&ts=true"
import script from "./CenterHCPList.vue?vue&type=script&lang=ts"
export * from "./CenterHCPList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Center/CenterHCPList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f4a90e24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f4a90e24', __exports__)) {
    api.reload('f4a90e24', __exports__)
  }
  
  module.hot.accept("./CenterHCPList.vue?vue&type=template&id=f4a90e24&ts=true", () => {
    api.rerender('f4a90e24', render)
  })

}


export default __exports__